<div class="box">
    <div class="itax-body">
        <div class="container position-relative w-100 h-100">
            <div class="row d-flex justify-content-center">
                <div class="col-12">
                    <h2 class="h2 w-100 text-center mb-10px">iTAX {{year}}</h2>
                    <p class="p2 text-center sub-text text-gray-medium mb-0">
                        อยากได้เงินคืนภาษีสูงสุด แต่ไม่รู้จะเริ่มต้นยังไง? <span class="font-weight-bold">งาน iTAX {{year}} เทศกาลลดหย่อนภาษีประจำปี</span>
                        จัดมาเพื่อคุณโดยเฉพาะ ทุกส่วนในงานถูกเตรียมให้ง่ายที่สุดเพื่อคุณทั้งหมดแล้ว
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
